import { createApi } from "@reduxjs/toolkit/query/react";

import axiosBaseQuery from "../rtk-query-axios.service";
import { APP_BASE_URL, GET_SYSTEM_CONFIGURATION } from "../../../Common/EndPoints";

type SystemConfigurationMutationParams = {
    params: {
        id: string;
    };
};

type SystemConfiguration = {
    id: string;
    code: string;
    alias: string;
};

type SystemConfigurationMutationBody = {
    body: {
        code: string;
        alias: string;
    };
};

export const systemConfigurationApi = createApi({
    reducerPath: "systemConfigurationAPI",
    baseQuery: axiosBaseQuery,
    tagTypes: ["system-configuration"],
    endpoints: (builder) => ({
        getSystemConfiguration: builder.query<SystemConfiguration[], { with_map?: boolean } | void>({
            query: (params) => ({
                url: APP_BASE_URL + GET_SYSTEM_CONFIGURATION,
                method: "GET",
                params,
            }),
            providesTags: ["system-configuration"],
            transformResponse: (_response: { error: any; success: any; data: SystemConfiguration[] }): SystemConfiguration[] => _response.data,
        }),
        postSystemConfiguration: builder.mutation<any, SystemConfigurationMutationBody>({
            query: ({ body }: SystemConfigurationMutationBody) => {
                return {
                    url: APP_BASE_URL + GET_SYSTEM_CONFIGURATION,
                    method: "POST",
                    params: {
                        softwareAlias: body.alias,
                        softwareCode: body.code,
                    }
                };
            },
            invalidatesTags: ["system-configuration"],
        }),
        editSystemConfiguration: builder.mutation<any, SystemConfigurationMutationParams & SystemConfigurationMutationBody>({
            query: ({ params, body }: SystemConfigurationMutationParams & SystemConfigurationMutationBody) => {
                return {
                    url: APP_BASE_URL + GET_SYSTEM_CONFIGURATION + `/${params.id}`,
                    method: "PUT",
                    params: {
                        softwareAlias: body.alias,
                        softwareCode: body.code,
                    }
                };
            },
            invalidatesTags: ["system-configuration"],
        }),
    }),
});
